import Swiper from "swiper";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

export const actionsSlider = (): Swiper | null => {
  const el = document.querySelector<HTMLElement>(".p-top-actions-slider");
  if (!el) return null;

  return new Swiper(el, {
    modules: [Navigation],
    slidesPerView: 1.6,
    centeredSlides: true,
    spaceBetween: 0,
    loop: true,
    navigation: {
      nextEl: ".p-top-actions-slider__arrow.--next",
      prevEl: ".p-top-actions-slider__arrow.--prev",
    },
    breakpoints: {
      768: {
        slidesPerView: 4.75,
        centeredSlides: true,
        navigation: {
          nextEl: ".p-top-actions-slider__arrow.--prev",
          prevEl: ".p-top-actions-slider__arrow.--next",
        },
      },
    },
  });
};
